import { Pipe, PipeTransform } from '@angular/core';
import { FileRecordDto } from '@careapp-group/ng-sdk';
import { decode } from 'blurhash';

/**
 * Given a file record with a blur, return a data image URL representing that blur.
 * By default, the blur will be 200 x 200.
 */
@Pipe({
    name: 'mediaBlurUrl',
    pure: true,
    standalone: false
})
export class MediaBlurUrlPipe implements PipeTransform {
  transform(value: FileRecordDto, width: number = 200, height: number = 200) {
    if (!value || !value.blur) {
      return;
    }

    const _blurPixels = decode(value.blur, width, height);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    const newImageData = new ImageData(_blurPixels, width, height);
    ctx.putImageData(newImageData, 0, 0);
    const url = canvas.toDataURL();

    return url;
  }
}
